import { Link } from "react-router-dom";

function ProductCard({ title, price, location, image, slug }) {
  const destination = "/products";

  return (
    <Link
      to={destination}
      className="bg-white cursor-pointer rounded-xl p-4 shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition block"
    >
      <div className="h-67 bg-gray-50 rounded-lg">
        <img
          src={image}
          alt={title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover rounded-lg"
        />
      </div>
      <div className="pt-4">
        <h3
          className="text-base text-gray-900 leading-snug min-h-[48px]"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {title}
        </h3>
        <div className="my-2 text-base font-bold text-gray-900">{price}</div>
        <div className="text-base text-gray-600">{location}</div>
      </div>
    </Link>
  );
}

export default ProductCard;
